import React from "react";
import Loading from "../Loading";
import { useSelector, useDispatch } from "react-redux";
import SignaturePad from "./SignaturePad";
import { fetchPutSignatureSh } from "../../features/action/fetchStatusFile";
import { getHtmlWithSignature } from "../../util/signature";

export const ShowOrderSH = ({ setShowOrderSH }) => {
  const { htmlContentSH: html, loading } = useSelector((state) => state.orderFile);
  const dispatch = useDispatch();
  const [signatureData, setSignatureData] = React.useState(null);
  const [receiverName, setReceiverName] = React.useState("");
  const [isSignatureModalOpen, setIsSignatureModalOpen] = React.useState(false);

  const handleCloseImage = (e) => {
    e.stopPropagation();
    setShowOrderSH(false);
  };
  const handleSignatureSave = (data) => {
    setSignatureData(data.signature);
    setReceiverName(data.name);
  };

  const handleSaveToDb = () => {
    const finalHtml = getHtmlWithSignature(html, signatureData, receiverName);
    if (finalHtml && html) {
      dispatch(fetchPutSignatureSh(html._id, finalHtml));
      setShowOrderSH(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-[#00000073] z-50 overflow-auto flex items-start justify-center show-order-overlay"
      onClick={handleCloseImage}
    >
      {loading && <Loading />}
      <div className="w-[1300px] relative my-[15%] bg-white rounded-lg py-[15px] px-[15px] show-order-modal">
        {html && html.htmlContent && typeof html.htmlContent === "string" && (
          <div className="relative">
            <div
              className="print-content"
              dangerouslySetInnerHTML={{
                __html: getHtmlWithSignature(html, signatureData, receiverName),
              }}
            />
            {!html.signature && (
              <div
                className="mt-4 flex justify-center gap-4 no-print"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => setIsSignatureModalOpen(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg shadow-md transition-colors duration-200"
                >
                  {signatureData ? "Re-sign" : "Sign"}
                </button>
                {signatureData && (
                  <button
                    onClick={handleSaveToDb}
                    className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg shadow-md transition-colors duration-200"
                  >
                    Save to DB
                  </button>
                )}
              </div>
            )}
            {isSignatureModalOpen && (
              <SignaturePad
                orderId={html.emailHeader}
                onSave={(data) => handleSignatureSave(data)}
                setIsSignatureModalOpen={setIsSignatureModalOpen}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
